<template>
  <div>
    <!-- Search Filters Section (optional) -->
    <div v-if="showSearchFilters" class="row">
      <div class="col-sm-12 col-md-12">
        <SearchFilters
          :search-filters="searchFilters"
          :search-placeholder="searchPlaceholder"
          :show-search-action-button="showSearchActionButton"
          :search-action-button-label="searchActionButtonLabel"
          :search-action-button-icon="searchActionButtonIcon"
          @search-value-changed="$emit('search-value-changed', $event)"
          @search-filter-changed="$emit('search-filter-changed', $event)"
          @search-action-button-clicked="$emit('search-action-button-clicked', $event)"
        />
      </div>
    </div>

    <hr v-if="showSearchFilters"/>

    <!-- Main Content Section -->
    <div class="table-responsive">
      <!-- Slot for the main content (table, cards, etc.) -->
      <slot name="content" :items="items">
        <!-- Default content if no slot provided -->
        <div v-if="!$slots.content" class="text-center mt-5 mb-5">
          <NoRecordsFound
            :is-loading="isLoading"
            :no-records-message="noRecordsMessage"
            :no-records-button-label="noRecordsButtonLabel"
            :no-records-button-action="noRecordsButtonAction"
          />
        </div>
      </slot>

      <!-- Pagination Controls (optional) -->
      <div v-if="showPagination && items.length > 0 && !isLoading" class="row">
        <div class="col-sm-12 col-md-5">
          <RowsPerPageSelect
            :records-per-page="recordsPerPage"
            :total-records="totalRecords"
            @records-per-page-changed="$emit('records-per-page-changed', $event)"
          />
        </div>
        <div class="col-sm-12 col-md-7">
          <Pagination
            :totalPages="totalPages"
            :perPage="recordsPerPage"
            :currentPage="currentPage"
            @pagechanged="$emit('pagechanged', $event)"
          />
        </div>
      </div>

      <!-- Empty State (when no items) -->
      <div v-if="!items.length && !isLoading" class="text-center mt-5 mb-5">
        <slot name="empty-state">
          <NoRecordsFound
            :is-loading="isLoading"
            :no-records-message="noRecordsMessage"
            :no-records-button-label="noRecordsButtonLabel"
            :no-records-button-action="noRecordsButtonAction"
          />
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import SearchFilters from "../shared/SearchFilters.vue";
import RowsPerPageSelect from "../shared/RowsPerPageSelect.vue";
import NoRecordsFound from "../shared/NoRecordsFound.vue";
import Pagination from "./../Pagination";

export default {
  components: {
    Pagination,
    SearchFilters,
    RowsPerPageSelect,
    NoRecordsFound,
  },
  props: {
    // Data properties
    items: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },

    // Pagination properties
    showPagination: {
      type: Boolean,
      default: true
    },
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 0
    },
    totalRecords: {
      type: Number,
      default: 0
    },
    recordsPerPage: {
      type: Number,
      default: 12
    },

    // Search properties
    showSearchFilters: {
      type: Boolean,
      default: true
    },
    searchFilters: {
      type: Array,
      default: () => []
    },
    noRecordsMessage: {
      type: String,
      default: 'No records found to display'
    },
    noRecordsButtonLabel: {
      type: String,
    },
    noRecordsButtonAction: {
      type: Function,
    },

    //Search Action Button
    searchPlaceholder: {
      type: String,
      default: 'Search...'
    },
    showSearchActionButton: {
      type: Boolean,
      default: false
    },
    searchActionButtonLabel: {
      type: String,
      default: 'Add'
    },
    searchActionButtonIcon: {
      type: String,
      default: 'fa fa-plus'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layouts/PageTableLayout.vue